import { Component, forwardRef, OnInit, Type } from '@angular/core';
import { Widget } from 'app/views/presentations/widgets/widget';
import { WidgetComponent } from 'app/views/presentations/widgets/widget.component';

export class HeaderWidget extends Widget {
    public type: string = 'Header';
    public icon: string = 'fa-header';
    public nameResourceKey: string = 'modules.editors.header.name';
    public componentType: Type<WidgetComponent> = HeaderWidgetComponent;
}

@Component({
    selector: 'psm-header-widget',
    templateUrl: 'header.widget.html'
})
export class HeaderWidgetComponent extends WidgetComponent {
    constructor() {
        super();
        this.content = { _: 'This is a header component' };
    }

    public async updateConfig(configs: any) {
        this.content = configs;
    }
}


// WEBPACK FOOTER //
// ./src/app/views/presentations/widgets/header/header.widget.ts